import React from 'react';
import CallToAction from '@framework/ui/Pages/Landing/Sections/CallToAction';
import StartActions from '@/dataroom/ui/components/Landing/dealvdr/components/StartActions';
import styles from './readyToLearn.module.scss';

const ReadyToLearn = () => (
  <CallToAction
    dataTest="readyToLearnSection"
    title="Ready to learn more?"
    description="Our fanatical sales and support teams are standing by. Book a demo or get an instant quote."
    actions={ <StartActions dividerClassName={ styles.divider } /> }
  />
);

export default ReadyToLearn;
